// The operator recovery key, built into the app. Every backup key is also wrapped to this key so
// Rhema support can help someone who lost every device and forgot their backup PIN, unless they
// turned on advanced protection. The key is RSA-OAEP-4096-SHA256 in Google Cloud KMS:
//   projects/siliconblast-chat/locations/global/keyRings/rhema/cryptoKeys/backup-recovery,
//   version 1, public key in apps/server/src/rhema/keys/backup-recovery-v1.pem.
// This is the SHA-256 of its DER SubjectPublicKeyInfo. The server serves the key, and the app
// wraps nothing to a key with another fingerprint. A self-hosted build with its own key sets
// VITE_RHEMA_OPERATOR_KEY_SHA256.

const BUILT_IN = "77c60e99518974101511e263a0a6a076b4858c6f1aa89bdf9c6e503c148fffbc";

export const OPERATOR_KEY_FINGERPRINT: string =
  (import.meta.env.VITE_RHEMA_OPERATOR_KEY_SHA256 as string | undefined) || BUILT_IN;
